import { SAGA_ACTIONS } from "../../../_config";
import { useApiCall } from "../appApiCallHook";

export function usePurchaseRequestApi() {
  const callApi = useApiCall();

  const GetPurchaseRequestCode = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.PURCHASE_REQUEST.GET_CODE, data, onSuccess, onError);
  };
  const GetPurchaseRequestStatusList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.PURCHASE_REQUEST.GET_STATUSES, data, onSuccess, onError);
  };
  const GetPurchaseRequestTypeList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.PURCHASE_REQUEST.GET_REQUEST_TYPES, data, onSuccess, onError);
  };
  const GetPurchaseRequestList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.PURCHASE_REQUEST.LIST, data, onSuccess, onError);
  };
  const GetPurchaseRequestById = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.PURCHASE_REQUEST.GET_REQUEST_BY_ID, data, onSuccess, onError);
  };
  const SavePurchaseRequest = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.PURCHASE_REQUEST.SAVE, data, onSuccess, onError);
  };
  const SaveProcessPurchaseRequest = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.PURCHASE_REQUEST.PROCESS, data, onSuccess, onError);
  };
  const DeletePurchaseRequest = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.PURCHASE_REQUEST.DELETE, data, onSuccess, onError);
  };
  const ExportPurchaseRequest = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.PURCHASE_REQUEST.EXPORT_TO_PDF, data, onSuccess, onError);
  };    
  const ExportPurchaseRequestXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.PURCHASE_REQUEST.EXPORT_TO_XLS, data,  onSuccess, onError);
  };

  return{
    GetPurchaseRequestCode,
    GetPurchaseRequestStatusList,
    GetPurchaseRequestTypeList,
    GetPurchaseRequestList,
    GetPurchaseRequestById,
    SavePurchaseRequest,
    DeletePurchaseRequest,
    ExportPurchaseRequest,
    ExportPurchaseRequestXLS,
    SaveProcessPurchaseRequest,
  };
}